import React from "react";

const AdvancedFinanceIcon = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="prompt-icon"
        d="M3.6757 12.1666C2.74148 12.1666 1.95064 11.8429 1.3032 11.1954C0.655754 10.548 0.332031 9.75714 0.332031 8.82292C0.332031 8.4307 0.39892 8.04953 0.532698 7.67942C0.666476 7.30931 0.858142 6.97386 1.1077 6.67309L3.46153 3.84225L1.9602 0.833252H10.0372L8.53586 3.84225L10.8897 6.67309C11.1393 6.97386 11.3309 7.30931 11.4647 7.67942C11.5985 8.04953 11.6654 8.4307 11.6654 8.82292C11.6654 9.75714 11.3399 10.548 10.689 11.1954C10.0383 11.8429 9.24914 12.1666 8.3217 12.1666H3.6757ZM5.9987 8.99342C5.66625 8.99342 5.38231 8.8757 5.14686 8.64025C4.91131 8.40481 4.79353 8.12086 4.79353 7.78842C4.79353 7.45586 4.91131 7.17186 5.14686 6.93642C5.38231 6.70097 5.66625 6.58325 5.9987 6.58325C6.33114 6.58325 6.61509 6.70097 6.85053 6.93642C7.08609 7.17186 7.20386 7.45586 7.20386 7.78842C7.20386 8.12086 7.08609 8.40481 6.85053 8.64025C6.61509 8.8757 6.33114 8.99342 5.9987 8.99342ZM4.37686 3.41659H7.62686L8.41536 1.83325H3.58203L4.37686 3.41659ZM3.6757 11.1666H8.3217C8.97647 11.1666 9.53075 10.9386 9.98453 10.4826C10.4384 10.0266 10.6654 9.47336 10.6654 8.82292C10.6654 8.5477 10.6181 8.28086 10.5237 8.02242C10.4293 7.76386 10.2944 7.53031 10.1192 7.32175L7.7012 4.41658H4.31286L1.88453 7.31142C1.70931 7.51997 1.57342 7.75525 1.47686 8.01725C1.38031 8.27914 1.33203 8.5477 1.33203 8.82292C1.33203 9.47336 1.56003 10.0266 2.01603 10.4826C2.47203 10.9386 3.02525 11.1666 3.6757 11.1666Z"
        fill="white"
      />
    </svg>
  );
};

export default AdvancedFinanceIcon;
